/** Warm the route chunk on intent without blocking the current document. */
const loaders: Record<string, () => Promise<unknown>> = {
  "/workspace": () => import("../pages/WorkbenchPage"),
  "/sales": () => import("../pages/SalesPage"),
  "/purchase": () => import("../pages/PurchasePage"),
  "/inventory": () => import("../pages/InventoryPage"),
  "/production": () => import("../pages/ProductionPage"),
  "/manufacturing": () => import("../pages/ManufacturingPage"),
  "/planning": () => import("../pages/PlanningPage"),
  "/equipment": () => import("../pages/EquipmentPage"),
  "/quality": () => import("../pages/QualityPage"),
  "/settlement": () => import("../pages/SettlementPage"),
  "/finance": () => import("../pages/FinancePage"),
  "/workflow": () => import("../pages/WorkflowPage"),
  "/analytics": () => import("../pages/AnalyticsPage"),
  "/master-data": () => import("../pages/MasterDataPage"),
  "/master-data/references": () => import("../pages/EnterpriseReferencesPage"),
  "/organization": () => import("../pages/OrganizationPage"),
  "/organization/positions": () => import("../pages/EnterpriseReferencesPage"),
  "/access": () => import("../pages/AccessPage"),
  "/subscription": () => import("../pages/SubscriptionPage"),
  "/tasks": () => import("../pages/TaskCenterPage"),
};

const warmed = new Set<string>();

export function prefetchBusinessPage(route: string) {
  const path = new URL(route, window.location.origin).pathname;
  const load = loaders[path];
  if (!load || warmed.has(path)) return;
  warmed.add(path);
  void load().catch(() => warmed.delete(path));
}
